// extracted by mini-css-extract-plugin
export default {"empty":"style_empty__5zR7M","list":"style_list__X5AUE","consentText":"style_consentText__Za2fF"};